(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lg-product-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__lgCarousel) return; window.__lgCarousel = true;
    const step = (track, dir) => {
      const card = track.firstElementChild;
      const w = card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      if (dir > 0 && atEnd) { track.scrollTo({ left: 0, behavior: 'smooth' }); return; }
      if (dir < 0 && track.scrollLeft <= 4) { track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' }); return; }
      track.scrollBy({ left: dir * w, behavior: 'smooth' });
    };
    document.addEventListener('click', (e) => {
      const b = e.target.closest('[data-lg-car]'); if (!b) return;
      const track = b.closest('.lg-section')?.querySelector('.lg-grid--carousel'); if (!track) return;
      step(track, Number(b.dataset.lgCar));
    });
    const initAuto = (root = document) => {
      root.querySelectorAll('.lg-grid--carousel[data-lg-autoplay]:not([data-init])').forEach((track) => {
        track.dataset.init = '1';
        const ms = Math.max(2000, Number(track.dataset.lgAutoplay) || 4000);
        let paused = false;
        ['mouseenter', 'touchstart', 'focusin'].forEach((ev) => track.addEventListener(ev, () => (paused = true), { passive: true }));
        ['mouseleave', 'touchend', 'focusout'].forEach((ev) => track.addEventListener(ev, () => (paused = false), { passive: true }));
        setInterval(() => { if (!paused && !document.hidden && track.scrollWidth > track.clientWidth) step(track, 1); }, ms);
      });
    };
    document.readyState !== 'loading' ? initAuto() : document.addEventListener('DOMContentLoaded', () => initAuto());
    document.addEventListener('shopify:section:load', (e) => initAuto(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
